import React from 'react';
import { ChatScreen } from '../shared/ChatScreen';

interface NurseChatScreenProps {
  onBack?: () => void;
}

export const NurseChatScreen = ({ onBack }: NurseChatScreenProps = {}) => {
  return <ChatScreen userRole="NURSE" onBack={onBack} chatUser={null}/>;
};
